import { Trans } from 'react-i18next'

import {
  GOOD_COMPANY_QUESTION,
  goodCompanyPNG,
  goodCompanyWEBP,
} from '~/pages/communication/goodCompany/libs/components/GoodCompanyCommunication/constants'
import { GoodCompanyCommunicationStyles as S } from '~/pages/communication/goodCompany/libs/components/GoodCompanyCommunication/styles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const GoodCompanyCommunication = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: GOOD_COMPANY_QUESTION,
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.ImageContainer>
          <S.ImageWrapper>
            <picture>
              <source srcSet={goodCompanyWEBP} type="image/webp" />
              <img src={goodCompanyPNG} alt="You're in great company" />
            </picture>
          </S.ImageWrapper>

          <S.ImageOverlay>
            <S.ImageCounter>
              <Trans
                ns="communication"
                i18nKey="onboarding.communicationGoodCompany.counter"
              />
            </S.ImageCounter>
            <S.ImageCounterLabel>
              <Trans
                ns="communication"
                i18nKey="onboarding.communicationGoodCompany.counterLabel"
              />
            </S.ImageCounterLabel>
          </S.ImageOverlay>
        </S.ImageContainer>

        <S.TitleGroup>
          <S.Title>
            <Trans
              ns="communication"
              i18nKey="onboarding.communicationGoodCompany.title"
            />
          </S.Title>
          <S.Subtitle>
            <Trans
              ns="communication"
              i18nKey="onboarding.communicationGoodCompany.subtitle"
            />
          </S.Subtitle>
        </S.TitleGroup>

        <S.Button type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.Button>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default GoodCompanyCommunication
